import React from "react";

const Recommened = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#FFE600"
      />
      <path
        d="M7.03125 3.75C7.03125 3.49112 6.82138 3.28125 6.5625 3.28125C6.30362 3.28125 6.09375 3.49112 6.09375 3.75C6.09375 4.69003 5.89013 5.24229 5.56063 5.56911C5.23034 5.89671 4.67705 6.09375 3.75 6.09375C3.49112 6.09375 3.28125 6.30362 3.28125 6.5625C3.28125 6.82138 3.49112 7.03125 3.75 7.03125C4.67393 7.03125 5.2281 7.23286 5.55954 7.56376C5.89083 7.89451 6.09375 8.44848 6.09375 9.375C6.09375 9.63388 6.30362 9.84375 6.5625 9.84375C6.82138 9.84375 7.03125 9.63388 7.03125 9.375C7.03125 8.4477 7.23304 7.89395 7.56349 7.56349C7.89395 7.23304 8.4477 7.03125 9.375 7.03125C9.63388 7.03125 9.84375 6.82138 9.84375 6.5625C9.84375 6.30362 9.63388 6.09375 9.375 6.09375C8.44457 6.09375 7.89171 5.89654 7.56241 5.56938C7.23373 5.24285 7.03125 4.69081 7.03125 3.75Z"
        fill="#23232F"
      />
      <path
        d="M12.3438 7.5C12.3438 7.24112 12.1339 7.03125 11.875 7.03125C11.6161 7.03125 11.4063 7.24112 11.4063 7.5C11.4063 8.99238 11.084 9.93526 10.4999 10.5146C9.91502 11.0948 8.97111 11.4063 7.5 11.4063C7.24112 11.4063 7.03125 11.6161 7.03125 11.875C7.03125 12.1339 7.24112 12.3438 7.5 12.3438C8.96798 12.3438 9.91278 12.6631 10.4988 13.2482C11.0847 13.8332 11.4063 14.7778 11.4063 16.25C11.4063 16.5089 11.6161 16.7188 11.875 16.7188C12.1339 16.7188 12.3438 16.5089 12.3438 16.25C12.3438 14.777 12.6633 13.8326 13.248 13.248C13.8326 12.6633 14.777 12.3438 16.25 12.3438C16.5089 12.3438 16.7188 12.1339 16.7188 11.875C16.7188 11.6161 16.5089 11.4063 16.25 11.4063C14.7739 11.4063 13.8304 11.0946 13.2469 10.5149C12.664 9.93582 12.3438 8.99316 12.3438 7.5Z"
        fill="#23232F"
      />
    </svg>
  );
};

export default Recommened;
